import { render, staticRenderFns } from "./TimerSignBoard.vue?vue&type=template&id=3076870a&scoped=true&"
import script from "./TimerSignBoard.vue?vue&type=script&lang=js&"
export * from "./TimerSignBoard.vue?vue&type=script&lang=js&"
import style0 from "./TimerSignBoard.vue?vue&type=style&index=0&id=3076870a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3076870a",
  null
  
)

export default component.exports